import { Routes, Route } from "react-router-dom";
import { useRef, useState } from "react";

import styles from "../../styles/base/Portal.module.scss";

import Header from "../../components/Header";
import Navigation from "../../components/admin/Navigation";
import Dashboard from "../admin/Dashboard";
import Translations from "../admin/Translations"

import { Input, Button } from "@qastanfit/qastan-ui"
import { dateToYYYYMMDD } from "../../functions/format";

interface LoginRef {
    name: string;
    password: string;
}

const Admin : React.FC = () => {
    const [isLoggedIn, setisLoggedIn] = useState(true);
    const [name, setname] = useState<string>();
    const [password, setpassword] = useState<string>();

    const login = () => {
        if(process.env.REACT_APP_SERVER_LINK?.includes("localhost")){
            if(name === "root" && password === "root"){
                setisLoggedIn(true)
            }
        }
        else {
            if(name === "dr" && password === dateToYYYYMMDD(new Date())){
                setisLoggedIn(true)
            }
        }
    }

    return (
    <>
    {!isLoggedIn ? 
        <div className={styles.admin_login}>
            <h1>Admin - Inloggen</h1>
            <Input onChange={(target:HTMLInputElement) => { setname(target.value) }} styling={{width:"100%"}} placeholder="Naam"/>
            <Input onChange={(target:HTMLInputElement) => { setpassword(target.value) }} styling={{width:"100%"}} type="password" placeholder="Wachtwoord"/>
            <Button onClick={()=>{login()}} styling={{width:"100%"}}>Inloggen</Button>
        </div>
    :
        <div className={styles.portal}>

            <Navigation />

            <div className={styles.content}>
                <Header />

                <Routes>
                    <Route path="*" element={<Dashboard />}/>
                    <Route path="vertalingen" element={<Translations />}/>
                </Routes>
            </div>
        </div>
    }        
    </>
    )
}

export default Admin;